import { Builder } from '@builder.io/react';
import { BUILDER_DIVIDER_NAMES } from '../BuilderComponentsName';
import { ShavingWaxingCalc } from '../../components/shared';

Builder.registerComponent(ShavingWaxingCalc, {
    name: BUILDER_DIVIDER_NAMES.ShavingAndWaxingCalc,
});
